import React, {Fragment, useEffect} from 'react';
import { useDispatch } from 'react-redux';

import HeaderUno from '../../Compartidos/HeaderUno';
import HeaderMetodos from '../../../AuxiliaresPaginas/HeaderMetodos';
import useConfigAuth from '../../../../Hooks/useConfigAuth';

// css
import {Container, ContainerImg, FlexLink, Descripcion } from '../../../Css/MetodosCSS/StyledMethods';
import { HrMetodos } from '../../../Css/StyledHeader';

import { solicitoListaEjerciciosAction } from '../../../../actions/solicitoInformacionEjercicioActions';

const CCSilabica = () => {

    const dispatch = useDispatch();
    const [config] = useConfigAuth();

    useEffect(() => {
        const informacion = {
            config,
            payload: {
                
            }
        }
        dispatch(solicitoListaEjerciciosAction(informacion))
    }, [])

    return (
        <Fragment>
            <HeaderUno />
            <HrMetodos margin='0 0.2rem 0.5rem 0.2rem' />
            <HeaderMetodos l1={"metodos/"} l2={"lenguaje/"} l3={"conciencia-fonologica/"} n1={"Métodos"} n2={"LENGUAJE"} n3={"CONCIENCIA FONOLÓGICA"} componente={"CCSILABICA"} paciente={true} bgcolor="#FF9B2A" color="white" width='96vw' shadow="0px 4px 4px rgba(0, 0, 0, 0.25)" display="none"/>

            <Container justify="center" direction="column" width="100%" height="100%" margin="0.5rem 0 0 0">
                <Container justify="space-around">
                    <FlexLink to={'/escritorio/metodos/lenguaje/conciencia-fonologica/cc-silabica/LEN20'}><ContainerImg src={`/img/portadas/LEN20.jpg`} alt=""/> <Descripcion>SILABA INICIAL</Descripcion></FlexLink>
                    <FlexLink to={'/escritorio/metodos/lenguaje/conciencia-fonologica/cc-silabica/LEN21'}><ContainerImg src={`/img/portadas/LEN21.jpg`} alt=""/> <Descripcion>CANTIDAD DE SÍLABAS</Descripcion></FlexLink>
                </Container>
                <Container justify="space-around" margin="50px 0px 0px 0px">
                    <FlexLink to={'/escritorio/metodos/lenguaje/conciencia-fonologica/cc-silabica/LEN22'}><ContainerImg src={`/img/portadas/LEN22.jpg`} alt=""/> <Descripcion>CANTIDAD DE SÍLABAS</Descripcion></FlexLink>
                    <FlexLink to={'/escritorio/metodos/lenguaje/conciencia-fonologica/cc-silabica/LEN23'}><ContainerImg src={`/img/portadas/LEN23.jpg`} alt=""/> <Descripcion>SÍLABA FINAL</Descripcion></FlexLink>
                    <FlexLink to={'/escritorio/metodos/lenguaje/conciencia-fonologica/cc-silabica/LEN24'}><ContainerImg src={`/img/portadas/LEN24.jpg`} alt=""/> <Descripcion>SÍLABA FINAL</Descripcion></FlexLink>
                </Container>
                <Container justify="space-around" margin="50px 0px 0px 0px">
                    <FlexLink to={'/escritorio/metodos/lenguaje/conciencia-fonologica/cc-silabica/LEN32-lista'}><ContainerImg src={`/img/portadas/LEN32.jpg`} alt=""/> <Descripcion>IDENTIFICAR SÍLABAS</Descripcion></FlexLink>
                    <FlexLink to={'/escritorio/metodos/lenguaje/conciencia-fonologica/cc-silabica/LEN36'}><ContainerImg src={`/img/portadas/LEN36.jpg`} alt=""/> <Descripcion>Ensamblar sílabas</Descripcion></FlexLink>
                </Container>
            </Container>
        </Fragment>     
    );
}
 
export default CCSilabica;